import { Logger } from 'one-logger';

export class TraceLogger implements Logger {
    private url: string;
    private key: string;

    constructor(url: string, key: string) {
        this.url = url;
        this.key = key;
    }

    fire(msg: any) {
        const { url } = this;
        fetch(url, {
            method: 'POST',
            body: JSON.stringify(msg),
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json',
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
        });
    }

    log(
        context?: any,
    ): void {
        this.fire({
            context,
            key: this.key,
            level: 'DEBUG',
        });
    }

    debug(
        title: string,
        description: string,
        context?: any,
    ): void {
        this.fire({
            title,
            description,
            context,
            key: this.key,
            level: 'DEBUG',
        });
    }

    error(
        title: string,
        description: string,
        context?: any,
    ): void {
        this.fire({
            title,
            description,
            context,
            key: this.key,
            level: 'ERROR',
        });
    }

    warn(
        title: string,
        description: string,
        context?: any,
    ): void {
        this.fire({
            title,
            description,
            context,
            key: this.key,
            level: 'WARN',
        });
    }

    info(
        title: string,
        description: string,
        context?: any,
    ): void {
        this.fire({
            title,
            description,
            context,
            key: this.key,
            level: 'INFO',
        });
    }
}
